<template>
  <div class="page">
    <b-container
        v-if="true"    
        class=""
    >
      <b-row>
        <b-col
          sm="12"
          md="12"
        >
            <div
              class="mb-4"
            >
              <iframe style="width: 100%; height: 50vh; border: none;" src="https://query.wikidata.org/embed.html#%23defaultView%3AMap%0Aselect%20%3Fartist%20%3FartistLabel%20%3Fdob%20%3Fdod%20%3Fpob%20%3FpobLabel%20%3FpobCoordinates%0AWHERE%20%7B%0A%20%20%3Fartist%20wdt%3AP569%20%3Fdob%20%3B%0A%20%20%20%20%20%20%20%20%20%20wdt%3AP570%20%3Fdod%20%3B%0A%20%20%20%20%20%20%20%20%20%20rdfs%3Alabel%20%3FartistLabel%20%3B%0A%20%20%20%20%20%20%20%20%20%20wdt%3AP19%20%3Fpob%20.%0A%20%20%3Fpob%20rdfs%3Alabel%20%3FpobLabel%20%3B%0A%20%20%20%20%20%20%20wdt%3AP625%20%3FpobCoordinates%20.%0A%20%20%20%20%20%20%20%20%20%20FILTER%28LANG%28%3FartistLabel%29%20%3D%20%22de%22%29.%0A%20%20%20%20%20%20%20%20%20%20FILTER%28LANG%28%3FpobLabel%29%20%3D%20%22de%22%29%0A%20%20%20%20%20%20%20%20%20%20FILTER%28CONTAINS%28%3FartistLabel%2C%20%22Mechlen%22%29%20%7C%7C%20CONTAINS%28%3FartistLabel%2C%20%22Becker%22%29%20%29.%0A%20%20%20%20%20%20%20%20%20%20FILTER%28%221888-01-01%22%5E%5Exsd%3AdateTime%20%3C%3D%20%3Fdob%20%26%26%20%3Fdob%20%3C%20%221889-01-01%22%5E%5Exsd%3AdateTime%20%7C%7C%20%221904-01-01%22%5E%5Exsd%3AdateTime%20%3C%3D%20%3Fdob%20%26%26%20%3Fdob%20%3C%20%221905-01-01%22%5E%5Exsd%3AdateTime%29.%0A%20%20%20%20%20%20%20%20%20%20FILTER%28%221961-01-01%22%5E%5Exsd%3AdateTime%20%3C%3D%20%3Fdod%20%26%26%20%3Fdod%20%3C%20%221962-01-01%22%5E%5Exsd%3AdateTime%20%7C%7C%20%221972-01-01%22%5E%5Exsd%3AdateTime%20%3C%3D%20%3Fdod%20%26%26%20%3Fdod%20%3C%20%221973-01-01%22%5E%5Exsd%3AdateTime%29.%0A%7D" referrerpolicy="origin" sandbox="allow-scripts allow-same-origin allow-popups" ></iframe>
            </div>
        </b-col>
        <b-col
          sm="12"
          md="4"
        >
          <!-- <h3
            class=""
          >
            Sidebar
          </h3>        
          <p>Inhalt Sidebar</p> -->
        </b-col>
      </b-row>
    </b-container>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'mapoutput',
  components: {
     
  },
  data () {
      return {
        localTechOutput: {}
      }
  },
  methods: {
    ...mapActions({
        
    })
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      
    })
  },
  created () {
    
  }
}
</script>
<style scoped>

</style>
